import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';
import { TrapType } from 'components/AnalyticsPage/TrapType';

export interface PiePeriodsChartData {
  id: number;
  date_time: string;
  enter: string;
}

export const getTrapDetailPiePeriodsChartData = async (slug: string, trapType: TrapType) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const data = await axiosInterceptor.get(`api/v1/traps/charts/time_period_signals/${slug}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      type: trapType,
    },
  });

  return data.data as PiePeriodsChartData[];
};
